import { Box } from 'shared/ui/Box';

import type { BackgroundProps, HeightProps, MaxHeightProps, MaxWidthProps } from 'styled-system';

import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

const fadeInWrapper = keyframes`
    from {
        opacity: 0;
        transform: translateY(-5%);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const fadeOutWrapper = keyframes`
    from {
        opacity: 1;
        transform: translateY(0);
    }
    to {
        opacity: 0;
        transform: translateY(-5%);
    }
`;

export const Overlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  animation-fill-mode: forwards;
  justify-content: center;
  z-index: 1000;
  animation: ${({ $isOpen }) =>
    $isOpen
      ? css`
          ${fadeIn} 0.3s ease forwards
        `
      : css`
          ${fadeOut} 0.3s ease forwards
        `};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
`;

export const ModalWrapper = styled.div<{
  max?: MaxHeightProps['maxHeight'];
  background?: BackgroundProps['background'];
  height?: HeightProps['height'];
  maxWidth?: MaxWidthProps['maxWidth'];
  $isOpen: boolean;
}>`
  cursor: default;
  padding: 20px;
  width: 100%;
  background: ${({ theme, background }) => background ?? theme.colors.purewhite};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: ${(props) => props.max ?? '80vh'};
  max-width: ${({ maxWidth }) => maxWidth ?? '1000px'};
  display: flex;
  flex-direction: column;
  position: relative;
  animation: ${({ $isOpen }) =>
    $isOpen
      ? css`
          ${fadeInWrapper} 0.3s ease forwards
        `
      : css`
          ${fadeOutWrapper} 0.3s ease forwards
        `};
  height: ${({ height }) => height ?? 'auto'};
`;

// Остальные стили без изменений
export const ContentWrapper = styled(Box)<{ isHideScroll?: boolean }>`
  width: 100%;
  overflow-y: ${({ isHideScroll }) => (isHideScroll ? 'hidden' : 'auto')};
  flex-grow: 1;
`;

export const ModalTitleWrapper = styled(Box)`
  padding: 0 0 5px 20px;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.black}`};
  margin: 0 -20px 15px -20px;
`;

export const CloseButton = styled(Box)`
  border: none;
  background: none;
  position: absolute;
  top: 15px;
  right: 30px;
  display: flex;
  z-index: 20;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`.withComponent('button');
